/** @deprecated This constant is being deprecated, please use string literal instead. Will be remove on or after 2024-07-31. */
const SEND_FAILED = 'send failed' as const;
/** @deprecated This constant is being deprecated, please use string literal instead. Will be remove on or after 2024-07-31. */
const SENDING = 'sending' as const;
/** @deprecated This constant is being deprecated, please use string literal instead. Will be remove on or after 2024-07-31. */
const SENT = 'sent' as const;

export { SEND_FAILED, SENDING, SENT };
